export default (to) => {
  const targetAnchor = document.querySelector(to);
  if (!targetAnchor) return;
  window.scrollTo({
    top: window.pageYOffset + document.querySelector(to).getBoundingClientRect().top - 70,
    behavior: 'smooth'
  });
};
